import { state } from "@src/state";
export const selectUser = () => state.auth.user;
export const selectLoginInProgress = () => state.auth.inProgress;
export const selectShouldRegister = () => state.auth.shouldRegister;
export const selectCorepassId = () => selectUser().corepassId;
export const selectAvatarUrl = () => selectUser().account.avatar.path;
// TODO: Once the premium feature is ready, this part should be changed
export const isPremiumUser = () => true;
